import { render, staticRenderFns } from "./step-review.vue?vue&type=template&id=3ddda4f2&scoped=true"
import script from "./step-review.vue?vue&type=script&lang=js"
export * from "./step-review.vue?vue&type=script&lang=js"
import style0 from "./step-review.vue?vue&type=style&index=0&id=3ddda4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddda4f2",
  null
  
)

export default component.exports